/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CustomWidgetPrefab.vue?vue&type=template&id=5b59ff18&scoped=true&"
import script from "./CustomWidgetPrefab.vue?vue&type=script&lang=js&"
export * from "./CustomWidgetPrefab.vue?vue&type=script&lang=js&"
import style0 from "./CustomWidgetPrefab.vue?vue&type=style&index=0&id=5b59ff18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59ff18",
  null
  
)

export default component.exports